import { FC, useEffect, useState } from "react";
import { Form } from "react-bootstrap";

interface IProps
  extends Omit<
    React.ComponentProps<typeof Form.Control>,
    "onBlur" | "onChange"
  > {
  row: {
    original: { id: string };
  };
  column: { id: string };
  onUpdate: (rowIndex: string, columnId: any, value: unknown) => void;
}

const UpdatableCell: FC<IProps> = ({
  value: defaultValue,
  row: {
    original: { id: index },
  },
  column: { id },
  onUpdate,
  type = "text",
  size = "sm",
  style,
  ...props
}) => {
  const [value, setValue] = useState(defaultValue);

  const _onChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    setValue(type === "number" ? Number(e.target.value) : e.target.value);

  const _onBlur = () => {
    if (defaultValue !== value) {
      onUpdate(index, id, value);
    }
  };

  useEffect(() => {
    setValue(defaultValue || "");
  }, [defaultValue]);

  return (
    <Form.Control
      value={value as string}
      onChange={_onChange}
      size={size}
      style={{ minWidth: 80, paddingRight: 0, ...style }}
      onBlur={_onBlur}
      step={type === "number" ? 0.01 : undefined}
      type={type}
      {...props}
    />
  );
};

export default UpdatableCell;
